import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '@/utils';

export interface SJInputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}

export const SJInput = forwardRef<HTMLInputElement, SJInputProps>(
  ({ className, label, error, id, ...props }, ref) => {
    return (
      <div className="flex flex-col gap-1.5">
        {label && (
          <label
            htmlFor={id}
            className="text-sm font-medium text-[var(--sj-text-secondary)]"
          >
            {label}
          </label>
        )}
        <input
          ref={ref}
          id={id}
          className={cn(
            'h-10 w-full rounded-[12px] border border-[var(--sj-border)] bg-[var(--sj-surface)] px-4 text-sm text-[var(--sj-text-primary)] placeholder:text-[var(--sj-text-muted)] transition-colors focus:border-primary-500 focus:outline-none focus:ring-2 focus:ring-primary-500/20',
            error && 'border-error-500 focus:border-error-500 focus:ring-error-500/20',
            className
          )}
          {...props}
        />
        {error && (
          <p className="text-xs text-error-600">{error}</p>
        )}
      </div>
    );
  }
);

SJInput.displayName = 'SJInput';
